import React from "react"
import { Button, SFXS } from "@orbital/games-frontend-library"

export default function Actions({ handleModal, startAuto, round, handleBetOnExplosion }: any) {

  const handlePlay = () => {
    startAuto(true)
    round.state === 3 && handleBetOnExplosion(true)
  }
  return (
    <>
      <Button
        width="100%"
        textColor="#181731"
        func={(b: boolean) => b && handlePlay()}
        SFX={SFXS.playSFX}
      >
        START AUTO
      </Button>
      <article>
        <p onClick={() => handleModal(false)}>BACK</p>
      </article>
    </>
  )
}
